// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import subcmtEntity from './entities/subcmt.json';
import subcmtMenu from '../pages/subcmt/menu.json';
import subcmtFullForm from '../pages/subcmt/forms/full.json';
import subcmtContextForm from '../pages/subcmt/forms/context.json';
import subcmtMiniForm from '../pages/subcmt/forms/mini.json';
import subcmtLookupForm from '../pages/subcmt/forms/lookup.json';
import subcmtTableView from '../pages/subcmt/views/table.json';
import subcmtDashboardView from '../pages/subcmt/views/dashboard.json';

/** Тип запису «Підкомітет» зі сторінками пакета: меню, форми та подання з pages/subcmt/. */
export const subcmtDefinition: IRecordTypeDefinition = {
  ...subcmtEntity,
  views: assembleViewSet({
      table: subcmtTableView,
      dashboard: subcmtDashboardView,
  }),
  form: subcmtFullForm,
  forms: { full: subcmtFullForm, context: subcmtContextForm, mini: subcmtMiniForm, lookup: subcmtLookupForm },
  menu: subcmtMenu,
} as IRecordTypeDefinition;
